<template lang="html">
  	<div class="">
        <p class="text-muted">Exports will be sent via email. Recurring options are coming soon. :)</p>
        <div class="alert alert-danger" v-if="Object.keys(errors).length > 0">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>
        <form @submit.prevent="queueExport">
            <div class="form-group">
                <label for="type">Client</label>
                <select class="form-control" v-model="form.client" id="type">
                    <option :value="null">Select a Client</option>
                    <option v-for="client in clients" :value="client.slug">{{ client.name }}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="type">Type</label>
                <select class="form-control" v-model="form.type" id="type">
                    <option :value="null">Select a Type</option>
                    <option value="campaign-goal">Campaign Goals + Ecommerce</option>
                    <option value="keyword-goal">Keyword Goal + Ecommerce</option>
                </select>
            </div>
            <div class="form-group">
                <label>Range</label>
                <div class="level">
                    <datepicker v-model="form.start" format="yyyy-MM-dd" icons-font="fa" placeholder="Start"></datepicker>
                    <datepicker v-model="form.end" format="yyyy-MM-dd" icons-font="fa" placeholder="End"></datepicker>
                </div>
            </div>
            <div class="form-group">
                <label for="increment">Increment</label>
                <select class="form-control" v-model="form.increment" id="increment">
                    <option :value="null">Select an Increment</option>
                    <option value="Total">Total</option>
                    <option value="Day">Day</option>
                    <option value="Month">Month</option>
                    <option value="Quarter">Quarter</option>
                    <option value="Year">Year</option>
                </select>
            </div>
            <div class="form-group">
                <div style="font-weight:bold;">
                    Options
                </div>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="form.byVendor"> Group By Vendor
                    </label>
                </div>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="form.byGoal"> Group By Goal
                    </label>
                </div>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="form.byType"> Include Goal Type
                    </label>
                </div>
            </div>
            <div class="form-group">
                <button class="btn btn-primary" type="submit" :class="{'btn-loading': loading}" :disabled="!submittable || loading">Export</button>
            </div>
  		</form>
  	</div>
</template>

<script>
import { datepicker, select } from 'vue-strap';
var Exports = require('./mixins/Exports');

export default {
    mixins: [Exports],

    components: { datepicker, vSelect: select },

    data() {
        return {
            form: {
                type: null,
                client: null,
                increment: null,
                start: '',
                end: '',
                byVendor: false,
                byGoal: false,
                byType: false,
            },
        }
    },

    mounted() {
        this.getClients();
    },

    computed: {
        submittable() {
            return Object.values(this.form).filter(n => n === null || n === '').length === 0;
        }
    },

    methods: {
        reset() {
            this.form = {
                type: null,
                client: null,
                increment: null,
                start: '',
                end: '',
                byVendor: false,
                byGoal: false,
                byType: false,
            }
        }
    }
}
</script>

<style lang="css" scoped>
    .level {
        display: flex;
        justify-content: space-between;
    }
    .datepicker {
        width: 48%;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/exports/GaExportBuilder.vue